import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';

import { SharedPipesModule } from '@app/shared/pipes/shared-pipes.module';
import { AddToCartModalComponent } from './components';
import { CartService, CartDialogService } from './services';
import { CartEffects } from './effects/cart.effects';
import { ReservationService } from '@app/shared/services/product';
import { reducers } from './reducers';

export const COMPONENTS = [AddToCartModalComponent];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatDialogModule,
    StoreModule.forFeature('cart', reducers),
    EffectsModule.forFeature([CartEffects]),
    SharedPipesModule
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  providers: [CartService, CartDialogService, ReservationService],
  entryComponents: [AddToCartModalComponent]
})
export class CartModule {}
